import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { TextLink } from '@techstyle/react-components';
import { FormattedMessage } from '@techstyle/react-intl';

const LearnMoreLinkWrapper = styled.div`
  text-align: center;
  margin-bottom: ${props => props.theme.spacing.medium}px;
`;

const LearnMoreLink = styled(TextLink)`
  color: ${props => props.theme.colors.active};
  font-size: 14;
  flex: 0 0 auto;
  position: relative;
  padding: 0px 0px 3px;
  background: transparent;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.4s ease-out;

  &::before {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 2px;
    width: 0px;
    transition: all 0.2s ease-out;
    background-color: ${props => props.theme.colors.active};
    white-space: normal;
  }

  &:hover {
    &::before {
      width: 100%;
      transition: all 0.2s ease-out;
    }
  }
`;

export default class VipLearnMoreLink extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    isBorderfreeCustomer: PropTypes.bool,
    isDowngradedMember: PropTypes.bool,
    isVip: PropTypes.bool,
    isVisitor: PropTypes.bool,
  };

  static defaultProps = {
    isBorderfreeCustomer: false,
    isDowngradedMember: false,
    isVisitor: true,
    isVip: false,
  };

  handleClick = () => {
    this.props.onClick && this.props.onClick();
  };

  render() {
    const {
      className,
      isBorderfreeCustomer,
      isDowngradedMember,
      isVip,
      isVisitor,
    } = this.props;

    const isEligibleNonMember =
      !isVip && !isBorderfreeCustomer && !isDowngradedMember;

    if (isEligibleNonMember || isVisitor) {
      return (
        <LearnMoreLinkWrapper className={className}>
          <LearnMoreLink onClick={this.handleClick}>
            <FormattedMessage
              id="site_pdp.flexible_membership_learn_more"
              defaultMessage="Learn About Savage X Rewards Membership"
            />
          </LearnMoreLink>
        </LearnMoreLinkWrapper>
      );
    }
    return null;
  }
}
